import Vue from 'vue'
export default function ajaxExtend(vueA){
	// 自定义拖拽指令--d3
	Vue.directive('drag',//自定义指令                   
	  {bind:function (el, binding) {
	      let oDiv = el;  //当前元素
	      let self = this; //上下文
	      var valxy={x:0,y:0};
	      oDiv.onmousedown = function (e) {
	       //鼠标按下，计算当前元素距离可视区的距离
	        let disX = e.clientX - oDiv.offsetLeft;
	        let disY = e.clientY - oDiv.offsetTop;
	        valxy={x:0,y:0};
	        document.onmousemove = function (e) {
	         //通过事件委托，计算移动的距离 
	          let l = e.clientX - disX;
	          let t = e.clientY - disY;


	          // console.log('e.pageX',e.pageX)
	          // console.log('e.pageY',e.pageY)
	        //   console.log('oDiv.offsetLeft',oDiv.offsetLeft)
	        // console.log('oDiv.offsetTop',oDiv.offsetTop)
	         //移动当前元素 
	          // oDiv.style.left = l + 'px';
	          // oDiv.style.top = t + 'px';
	           //将此时的位置传出去
	          // binding.value({x:e.pageX,y:e.pageY})
	          
	          // 传出当前xy值的变化
	          binding.value({x:l-valxy.x,y:t-valxy.y})
	          // 记录当前值
	          valxy={x:l,y:t};
	        };
	        document.onmouseup = function (e) {
	          
	          document.onmousemove = null;
	          document.onmouseup = null;
	         };
	      };
	    }
	  }
	);

	//全局返回上一页的方法
	Vue.prototype.back = function () {
	  window.history.back()
	}

	Vue.config.productionTip = false

}


// WEBPACK FOOTER //
// ./src/extend/vueAdd.js